/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetExecutionProfileChoiceRequestBody,
  SetExecutionProfileChoiceRequestBody$Outbound,
  SetExecutionProfileChoiceRequestBody$outboundSchema,
} from "../components/setexecutionprofilechoicerequestbody.js";

export type SetAssistantExecutionProfileChoiceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetAssistantExecutionProfileChoiceRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setExecutionProfileChoiceRequestBody: SetExecutionProfileChoiceRequestBody;
};

/** @internal */
export type SetAssistantExecutionProfileChoiceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetAssistantExecutionProfileChoiceSecurity$outboundSchema:
  z.ZodMiniType<
    SetAssistantExecutionProfileChoiceSecurity$Outbound,
    SetAssistantExecutionProfileChoiceSecurity
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setAssistantExecutionProfileChoiceSecurityToJSON(
  setAssistantExecutionProfileChoiceSecurity:
    SetAssistantExecutionProfileChoiceSecurity,
): string {
  return JSON.stringify(
    SetAssistantExecutionProfileChoiceSecurity$outboundSchema.parse(
      setAssistantExecutionProfileChoiceSecurity,
    ),
  );
}

/** @internal */
export type SetAssistantExecutionProfileChoiceRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetExecutionProfileChoiceRequestBody:
    SetExecutionProfileChoiceRequestBody$Outbound;
};

/** @internal */
export const SetAssistantExecutionProfileChoiceRequest$outboundSchema:
  z.ZodMiniType<
    SetAssistantExecutionProfileChoiceRequest$Outbound,
    SetAssistantExecutionProfileChoiceRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      setExecutionProfileChoiceRequestBody:
        SetExecutionProfileChoiceRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        setExecutionProfileChoiceRequestBody:
          "SetExecutionProfileChoiceRequestBody",
      });
    }),
  );

export function setAssistantExecutionProfileChoiceRequestToJSON(
  setAssistantExecutionProfileChoiceRequest:
    SetAssistantExecutionProfileChoiceRequest,
): string {
  return JSON.stringify(
    SetAssistantExecutionProfileChoiceRequest$outboundSchema.parse(
      setAssistantExecutionProfileChoiceRequest,
    ),
  );
}
